<template>
  <div class="tablelist">
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
    <div>
    </div>
      <template slot="sello" slot-scope="props">
        <div v-if="props.rowData.isLiquid === 'S'">
            NO
        </div>
        <div v-else>
            SI
        </div>
      </template>
      <template slot="editar" slot-scope="props">
        <div v-if="!(props.rowData.isLiquid === 'S')">
            No se puede editar
        </div>
        <div v-else class="reflist">
            <select class="form-control" id="EditOperator" @change="dataRefUpdate(props.rowData)">
                <option
                    v-for="itemList of OperatosList"
                    v-bind:value="itemList.idOperator"
                    :key="itemList.idOperator"
                    :selected="itemList.idOperator === props.rowData.idOperator"
                  >{{itemList.namOperator}}</option>
                </select>
        </div>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import IberoHelpers from '@/store/helpers.js'

export default {
  data () {
    return {
      term: null,
      student: null,
      perPage: '20',
      perPageOptions: ['4', '6', '10', '20'],
      users: this.InfoView,
      OperatosList: [],
      StatusOptions: [
        {
          id: 1,
          description: 'Activo',
        },
        {
          id: 2,
          description: 'Inactivo',
        },
      ],
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
    filterData: Array,
  },
  created () {
    var listOperator = IberoHelpers.getOperatorList(this.$store)
    listOperator.then(Response => {
      this.OperatosList = Response.data
    })
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      if (((!this.term) || (this.term.length < 1))) {
        return this.users
      }

      return this.users.filter(item => {
        if (this.term && this.term.length >= 1) {
          return item.idBanner.toLowerCase().startsWith(this.term.toLowerCase())
        } else {
          return item
        }
      })
    },
  },
  methods: {
    dataRefUpdate (dataInf) {
      event.periodo = dataInf
      var resulTotal = this.OperatosList.find(element => element.idOperator.toString() === event.target.value.toString())
      this.method(event, resulTotal)
    },
    dataUser (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

/*va-button va-button--outline va-button--normal*/
.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata{
  cursor: pointer;
}

.reflist{
    margin-top: -15px;
}
</style>
